import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscription } from 'core/api/subscription';
import { getNumericDate } from 'utils/dateTimeFormat';
import { useSessionStore } from 'stores/session';

const CandidateSubscriptionView: FC = () => {
    const { t } = useTranslation();
    const subscription = useSubscription();
    const user = useSessionStore((s) => s.user);

    if (subscription !== null && subscription.expirationDate) {
        return (
            <p>
                {t('profile.license.valid-license', {
                    expirationDate: getNumericDate(subscription.expirationDate),
                })}
            </p>
        );
    } else if (user !== null && user.firstLoginDate) {
        return (
            <p>
                {t('profile.license.invalid-license-trial', {
                    expirationDate: user.trialEndDate && getNumericDate(user.trialEndDate),
                })}
            </p>
        );
    }

    return <p>{t('profile.license.invalid-license')}</p>;
};

export default CandidateSubscriptionView;
